import { Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import GoldSubNav from "./GoldSubNav";

// Iter 273 — Shared shell used by every /gold/* page.  Owns the GOLD
// gate check, the hero band and the sub-navigation.  Children render
// beneath the sub-nav.
export default function GoldSectionLayout({
  title,
  subtitle,
  actions,
  children,
  testid = "gold-page",
}) {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-black text-amber-300 flex items-center justify-center">
        Please log in to access GOLD.
      </div>
    );
  }
  if (!user.is_gold && !user.is_admin) {
    return (
      <div
        className="min-h-screen bg-black text-amber-300 flex flex-col items-center justify-center p-8"
        data-testid="gold-locked"
      >
        <Sparkles className="w-14 h-14 mb-3 text-amber-400" />
        <h1 className="text-3xl font-display font-black tracking-widest mb-2">GOLD MEMBERSHIP</h1>
        <p className="text-amber-500/70 text-sm mb-4">
          This is a premium tier. Ask an admin to activate GOLD on your account.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-amber-100 relative overflow-x-hidden" data-testid={testid}>
      {/* Iter 275l — Editorial-luxury ambient wash to match the new /gold hub.
          Radial gold glow at the top; subtle amber grain overlay. */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-[520px] opacity-40"
        style={{
          background:
            "radial-gradient(60% 80% at 20% 0%, rgba(251,191,36,0.15), transparent 60%), " +
            "radial-gradient(50% 60% at 100% 0%, rgba(251,191,36,0.08), transparent 55%)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4'><rect width='1' height='1' fill='%23fbbf24'/></svg>\")" }}
      />

      <div className="relative max-w-7xl mx-auto px-4 py-10">
        {/* Hero */}
        <div className="mb-8 pb-6 border-b border-amber-500/20 flex items-start justify-between flex-wrap gap-3">
          <div className="flex items-center gap-4">
            <div className="p-2.5 rounded-lg bg-gradient-to-br from-amber-500 to-yellow-400 shadow-lg shadow-amber-500/40">
              <Sparkles className="w-6 h-6 text-black" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-amber-500/70 font-black mb-1">
                GOLD · Institutional Intelligence
              </div>
              <h1
                className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-amber-50"
                style={{ fontFamily: '"Playfair Display", "Fraunces", Georgia, serif' }}
              >
                {title}
              </h1>
              {subtitle && (
                <p className="text-sm text-amber-100/60 max-w-2xl mt-2 leading-relaxed">{subtitle}</p>
              )}
            </div>
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>

        <GoldSubNav />

        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
}
